import { useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API_BASE } from "../../lib/api";
import { useAdminAuth } from "../../lib/auth";

const AdminLogin = () => {
  const { login, isAuthed } = useAdminAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchParams.get("expired") === "1") {
      toast.error("Session expired. Please sign in again.", { id: "session-expired" });
    }
  }, [searchParams]);

  if (isAuthed) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_BASE}/admin/login`, { email, password });
      login(data.token, data.email);
      toast.success("Welcome");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid="admin-login-page" style={{ background: "var(--bg)" }}>
      <div className="hidden md:block overflow-hidden" style={{ background: "#0a0a0a" }}>
        <div className="h-full w-full flex flex-col justify-between p-12 text-white">
          <div className="overline" style={{ color: "rgba(255,255,255,0.7)" }}>Swenkville · Admin</div>
          <div>
            <h1 className="font-display uppercase tracking-tighter leading-[0.85] text-6xl">
              House<br/>controls.
            </h1>
            <p className="mt-6 text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>
              The console for the private label.
            </p>
          </div>
          <div className="overline" style={{ color: "rgba(255,255,255,0.4)" }}>Restricted access · authorized only</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-10">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
          <div className="overline mb-3">Admin Access</div>
          <h1 className="font-display text-4xl uppercase tracking-tighter">Sign in.</h1>
          <div className="mt-10 space-y-8">
            <input
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-bare"
              data-testid="admin-login-email"
            />
            <input
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-bare"
              data-testid="admin-login-password"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full mt-10" data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
